import { Component, ElementRef, HostListener, Input, ViewChild } from '@angular/core';
import { DropdownRegistryService, RegisterableDropdown } from './dropdown-registry.service';

@Component({
    selector: 'dropdown',
    template: `
        <div class="dropdown">
            <button (click)="toggle()" [ngClass]="{active: isDropdownVisible}">
                <i *ngIf="icon && !svg" class="icon" [class]="icon">&nbsp;</i>
                <svg-icon *ngIf="icon && svg" [name]="icon" class="bottom-svg-modal-icon"></svg-icon>
                <span *ngIf="label">{{ label }}</span>
                <chevron *ngIf="chevron" direction="{{isDropdownVisible ? 'up' : 'down'}}"></chevron>
            </button>
            <div class="modal-placeholder" [class.dropup]="openUpward">
                <div *ngIf="isDropdownVisible" #menu class="profile-modal" (click)="$event.stopPropagation();">
                    <ng-content></ng-content>
                    <ul *ngIf="dropdownData?.length" class="action-menu">
                        <li *ngFor="let item of dropdownData">
                            <a [href]="item.href" [target]="tryGetTarget(item)" (click)="tryGetAction(item, $event)">
                                <svg-icon *ngIf="item.icon" [name]="item.icon"></svg-icon> {{ (item.label | stLoc) || item.label}}
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    `
})
export class DropdownComponent implements RegisterableDropdown {
    @Input() dropdownData: DropdownData[] = [];
    @Input() icon?: string;
    @Input() svg?: boolean;
    @Input() label?: string;
    @Input() chevron: boolean = false;

    @ViewChild('menu') menu?: ElementRef<HTMLElement>;

    isDropdownVisible = false;
    openUpward = false;

    constructor(
        private host: ElementRef,
        private registry: DropdownRegistryService,
    ) { }

    toggle() {
        this.isDropdownVisible = !this.isDropdownVisible;
        if (this.isDropdownVisible) {
            this.registry.opened(this);
            // measure after the menu renders
            setTimeout(() => this.decidePlacement());
        } else {
            this.registry.closed(this);
        }
    }

    private decidePlacement() {
        const trigger = this.host.nativeElement.querySelector('button') as HTMLElement;
        const menuEl = this.menu?.nativeElement;
        if (!trigger || !menuEl) {
            return;
        }
        const triggerRect = trigger.getBoundingClientRect();
        const menuHeight = menuEl.offsetHeight;
        const spaceBelow = window.innerHeight - triggerRect.bottom;
        const spaceAbove = triggerRect.top;
        this.openUpward = spaceBelow < menuHeight && spaceAbove > spaceBelow;
    }

    forceClose() {
        this.isDropdownVisible = false;
        this.openUpward = false;
    }

    @HostListener('document:click', ['$event'])
    onDocumentClick(event: Event) {
        const clickedInside = this.host.nativeElement.contains(event.target);
        if (!clickedInside && this.isDropdownVisible) {
            this.isDropdownVisible = false;
            this.openUpward = false;
            this.registry.closed(this);
        }
    }

    tryGetTarget(item: DropdownData) {
        return item.target ? item.target : '';
    }

    tryGetAction(item: DropdownData, event: Event) {
        if (!item.href) {
            event.preventDefault();
        }
        this.isDropdownVisible = false;
        this.openUpward = false;
        this.registry.closed(this);
        return item.action ? item.action() : '';
    }
}

export interface DropdownData {
    label: string,
    icon?: string,
    href?: string;
    target?: string;
    action?(): void;
}